import { gql, useMutation } from "@origin-digital/kraxi";

import {
  UpdateUserDob,
  UpdateUserDobVariables,
} from "./graphql-types/UpdateUserDob";
import {
  UpdateUserRichAddress,
  UpdateUserRichAddressVariables,
} from "./graphql-types/UpdateUserRichAddress";
import {
  UpdateCommsDeliveryPreference,
  UpdateCommsDeliveryPreferenceVariables,
} from "./graphql-types/UpdateCommsDeliveryPreference";
import {
  UpdateUserEmail,
  UpdateUserEmailVariables,
} from "./graphql-types/UpdateUserEmail";
import {
  UpdateUserLandline,
  UpdateUserLandlineVariables,
} from "./graphql-types/UpdateUserLandline";
import {
  UpdateUserMobile,
  UpdateUserMobileVariables,
} from "./graphql-types/UpdateUserMobile";
import { krakenClient } from "./queries";

export const useUpdateUserRichAddress = () =>
  useMutation<UpdateUserRichAddress, UpdateUserRichAddressVariables>(
    gql`
      mutation UpdateUserRichAddress($address: RichAddressInput!) {
        updateUserRichAddress(address: $address) {
          viewer {
            accounts {
              billingAddress
              number
            }
          }
        }
      }
    `,
    {
      client: krakenClient,
    }
  );

export const useUpdateContactPreference = () => {
  return useMutation<
    UpdateCommsDeliveryPreference,
    UpdateCommsDeliveryPreferenceVariables
  >(
    gql`
      mutation UpdateCommsDeliveryPreference(
        $accountNumber: String!
        $commsDeliveryPreference: CommsDeliveryPreference!
      ) {
        updateCommsDeliveryPreference(
          input: {
            accountNumber: $accountNumber
            commsDeliveryPreference: $commsDeliveryPreference
          }
        ) {
          account {
            ... on AccountType {
              commsDeliveryPreference
            }
          }
        }
      }
    `,
    {
      client: krakenClient,
    }
  );
};

export const useUpdateDob = () =>
  useMutation<UpdateUserDob, UpdateUserDobVariables>(
    gql`
      mutation UpdateUserDob($dateOfBirth: Date!) {
        updateUser(input: { dateOfBirth: $dateOfBirth }) {
          viewer {
            dateOfBirth
          }
        }
      }
    `,
    {
      client: krakenClient,
    }
  );

export const useUpdateEmail = () =>
  useMutation<UpdateUserEmail, UpdateUserEmailVariables>(
    gql`
      mutation UpdateUserEmail($email: String!) {
        updateUser(input: { email: $email }) {
          viewer {
            email
          }
        }
      }
    `,
    {
      client: krakenClient,
    }
  );

export const useUpdateLandline = () =>
  useMutation<UpdateUserLandline, UpdateUserLandlineVariables>(
    gql`
      mutation UpdateUserLandline($phone: String!) {
        updateUser(input: { landline: $phone }) {
          viewer {
            landline
          }
        }
      }
    `,
    {
      client: krakenClient,
    }
  );

export const useUpdateMobile = () =>
  useMutation<UpdateUserMobile, UpdateUserMobileVariables>(
    gql`
      mutation UpdateUserMobile($phone: String!) {
        updateUser(input: { mobile: $phone }) {
          viewer {
            mobile
          }
        }
      }
    `,
    {
      client: krakenClient,
    }
  );
